import { render, staticRenderFns } from "./queue-log-table.vue?vue&type=template&id=1251667f"
import script from "./queue-log-table.vue?vue&type=script&lang=js"
export * from "./queue-log-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports